<template>
  <div
    class="wt-context-menu"
    ref="popper"
    v-show="isVisible"
    tabindex="-1"
    v-click-outside="close"
    @contextmenu.capture.prevent
  >
    <ul>
      <slot :contextData="contextData" />
    </ul>
  </div>
</template>

<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/* COMPONENTS - PAGE */
import Popper from "popper.js";
import ClickOutside from "vue-click-outside";

export default {
  props: {
    boundariesElement: {
      type: String,
      default: "body"
    }
  },
  components: {
    /*Popper,*/
  },
  computed: {
    isVisible() {
      return this.opened;
    },
    objSelected() {
      return this.$store.state.objSelected;
    }
  },

  data() {
    return {
      opened: false,
      contextData: {}
    };
  },

  directives: {
    ClickOutside
  },

  methods: {
    executeAction(payload) {
      const row = {};
      row[`${this.contextData.actions[payload].key}`] = this.contextData.row[
        `${this.contextData.actions[payload].key}`
      ];
      const action = this.contextData.actions[payload].urlAction;
      const url =  `${baseApiUrl}:${baseApiPort}/${action}`

      axios.post(url, row)
        .then(() => {
          this.$store.commit("alert/setShowAlert", true);
          this.$store.commit("alert/setMessage", "Action successfully!");
          this.$store.commit("alert/setSuccessvariant");
          this.reset();
          this.$store.commit("setShowLoading", false);
        })
        .catch(error => {
          this.$store.commit("alert/setShowAlert", true);
          this.$store.commit("alert/setMessage", error.response.data);
          this.$store.commit("alert/setDangervariant");
          this.$store.commit("setShowLoading", false);
        });
      this.close();
    },

    reset() {     
      this.$store.commit("setAction", 'reset');
      this.$store.commit("setObjShared", {});
      this.$store.commit("setShowGrid", true);
    },

    open(evt, contextData) {
      this.opened = true;
      this.contextData = contextData;

      if (this.popper) {
        this.popper.destroy();
      }

      this.popper = new Popper(this.referenceObject(evt), this.$refs.popper, {
        placement: "right-start",
        modifiers: {
          preventOverflow: {
            boundariesElement: document.querySelector(this.boundariesElement)
          }
        }
      });
      // Recalculate position
      this.$nextTick(() => {
        this.popper.scheduleUpdate();
      });
    },

    close() {
      this.opened = false;
      this.contextData = null;
    },

    referenceObject(evt) {
      const left = evt.clientX;
      const top = evt.clientY;
      const right = left + 1;
      const bottom = top + 1;
      const clientWidth = 1;
      const clientHeight = 1;

      function getBoundingClientRect() {
        return { left, top, right, bottom };
      }

      const obj = { getBoundingClientRect, clientWidth, clientHeight };
      return obj;
    }
  },
  beforeDestroy() {
    if (this.popper !== undefined) {
      this.popper.destroy();
    }
  }
};
</script>
